import es from './es'
import en from './en'
import ca from './ca'

export default {
  'en': en,
  'es': es,
  'ca': ca,
  'ENGLISH': en,
  'SPANISH': es,
  'CATALAN': ca
}
